const DEFAULT_PLAN_STATUS = "active";

/** Legacy `deprecated` lifecycle is merged into `archived` (read + write). */
export function normalizePlanLifecycleStatus(status) {
  if (status === "deprecated") return "archived";
  return status || DEFAULT_PLAN_STATUS;
}
